// extracted by mini-css-extract-plugin
export default {"container":"attachment-image_container__g2fMR","content":"attachment-image_content__jqU9x","loader":"attachment-image_loader__kXUsd","spinner":"attachment-image_spinner__lWlNe"};